import React from "react";
import loaderCarouselSvg from "../../assets/images/loader-carousel.svg";
import "./styles.scss";

const CAROUSEL_COUNT = 3;

const Loader = () => {
  return (
    <div className="new-loader-container">
      <div className="loader">
        {Array.from({ length: CAROUSEL_COUNT }, (_, index) => (
          <img
            key={`carousel-${index + 1}`}
            src={loaderCarouselSvg}
            alt="loader"
            className={`carousel carousel${index + 1}`}
          />
        ))}
      </div>
    </div>
  );
};

export default Loader;
